import { NgModule } from '@angular/core';
import { DownloadCardComponent } from './download-card.component';

@NgModule({
  imports: [DownloadCardComponent],
  exports: [DownloadCardComponent]
})
export class DownloadCardModule {}
